// extracted by mini-css-extract-plugin
module.exports = {"hero":"Home_hero__B0w79","rainbow":"Home_rainbow__ySLM1","social":"Home_social__ZkLrj"};